import { BASE_ROUTE, RouteParams } from "../../../constants";

export const BASE_TRAINING_ROUTE = `${BASE_ROUTE}/training`;

export const TrainingPages = {
  learningDashboard: {
    path: `/learning-dashboard`,
    generateLink: (organisationId: string | number, projectId: number | string) =>
      `/${BASE_TRAINING_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/learning-dashboard`
  }
};
